<template>
	<div class="row">
		<div class="col-md-6">
			<div class="auth-wrapper" style="background: #e9f2ec">
				<div class="auth-content" style="width: 500px">
					<div class="card">
						<div class="row">
							<div class="col-md-12">
								<div
									class="card-body"
									style="padding-top: 0px; padding-bottom: 0px"
								>
									<div class="align-items-center text-center">
										<a href="/">
											<img
												src="assets/images/inec.jpeg"
												alt=""
												class="img-fluid mb-4"
											/>
										</a>
									</div>
									<Alert></Alert>
									<zoom-center-transition :duration="200" mode="out-in">
										<!-- your content here -->
										<router-view></router-view>
									</zoom-center-transition>
								</div>
							</div>
						</div>
					</div>
					<!-- <div class="align-items-center text-center mt-2">
				<img
					src="assets/images/eulong.jpg"
					alt=""
					class="img-fluid mb-4"
					style=""
				/>
			</div> -->
				</div>
			</div>
		</div>
		<div class="col-md-6">
			<div class="auth-wrapper" style="background: transparent">
				<div class="auth-content" style="width: 100%">
					<div
						class="card-body"
						style="padding-top: 0px; padding-bottom: 0px; color: #fff"
					>
						<div class="mb-5">
							<h2 class="fw-bold mb-4 text-white">
								Welcome to the Political Parties Financial Reporting and Audit System (PFRAS)
							</h2>
							<p class="text-white">
								PFRAS is a secure online platform designed to simplify the
								submission, management, and analysis of political party financial
								reports. The system enables political parties and electoral
								stakeholders to track income and expenditure, ensure compliance
								with regulatory requirements, and enhance transparency in
								political parties finance reporting.
							</p>
						</div>
						<div class="mb-5">
							<h3 class="card-title mb-0 fw-bold text-white">
									Important Instructions
								</h3>
							<p>
								<ul class="">
									<li class="">Only Official Emails Are Allowed</li>
									<li class="">Ensure Your Login Credentials Are Secure</li>
									<li class="">Do not share your username and password with anyone.</li>
									<li class="">If you suspect any unauthorized access, reset your password immediately.</li>
									<li class="">Use recommended browsers: Google Chrome, Mozilla Firefox, or Microsoft Edge.</li>
									<li class="">Ensure a stable internet connection for a seamless experience</li>
									<li class="">Users have specific roles and are responsible for the accuracy of submitted reports.</li>
									<li class="">For the political parties, the portal is accessible only during open submission periods.</li>
								</ul>
							</p>
						</div>
						<div>
							<h3 class="fw-bold mb-3 text-white">Need Help?</h3>
							<div class="d-flex align-items-center mb-2">
								<i class="bi bi-envelope-fill me-2" style="font-size: 1.2rem;"></i>
								<span>Email: epm@inec.gov.ng</span>
							</div>
							<div class="d-flex align-items-center">
								<i class="bi bi-telephone-fill me-2" style="font-size: 1.2rem;"></i>
								<span>Phone: 4632 OR 0700-CALL-INEC</span>
							</div>

						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import { ZoomCenterTransition } from "vue2-transitions";
import Alert from "@/components/Alert.vue";
export default {
	components: {
		Alert,
		ZoomCenterTransition,
	},
};
</script>
<style>
.btn-info {
	background: #29623c;
	border-color: #29623c;
}
.btn-info:hover {
	background-color: #268e49;
	border-color: #268e49;
}
body {
	background: #29623c;
}
.img-fluid {
	height: 100px;
}
p{
	font-size: 14px;
}
</style>
